export default "__VITE_ASSET__SkUn8GIb__"